import * as popupActions from './popupActions';
import actionConfig from '../../defaults/popupActions.json';

export default class PopupActionCreator {
  constructor(view, options) {
    this.startup(view, options);
  }

  startup(view, options) {
    // Register popup actions with corresponding layers
    Object.keys(actionConfig).forEach(key => {
      const action = actionConfig[key];
      if (
        !view.popup.actions.find(
          existingAction => existingAction.id === action.id
        )
      ) {
        const { title, id, className, layer: targetLayer } = action;
        const layer = options.layerLookup[targetLayer];
        layer.popupTemplate.actions = layer.popupTemplate.actions || [];
        layer.popupTemplate.actions.push({ title, id, className });
      }
    });

    // Register popup action handlers
    view.popup.on('trigger-action', event => {
      // If action is not configured, don't do anything
      if (!actionConfig[event.action.id]) {
        return;
      }

      const handlerName = actionConfig[event.action.id].handler;
      popupActions[handlerName](event, options.history);
    });
  }
}



// WEBPACK FOOTER //
// ./src/esri/widgets/PopupActionCreator.js